import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, NgModule } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  @Input() @HostBinding('attr.isSmall') isSmall = false;
}

@NgModule({
  imports: [CommonModule],
  declarations: [ChipComponent],
  exports: [ChipComponent],
})
export class ChipModule {}
